import { gql } from '@apollo/client';

export const MEDIA_FRAGMENT = gql`
  fragment Media on Media {
    format
    url
    title
    iframely
    href
    focusPoint
  }
`;
